import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "step__basic" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите или введите название проектировщика", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Пример: ООО \"КГ \"Север\"\"", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите или введите название изготовителя", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Пример: ООО \"КГ \"Север\"\"", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _hoisted_4,
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.designer_name_title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.designer_name_title) = $event)),
          editable: "",
          options: _ctx.designer_name_options,
          optionLabel: "name",
          placeholder: _ctx.designer_name_default.name,
          style: {"width":"480px"},
          onChange: _ctx.designer_name_change
        }, null, 8, ["modelValue", "options", "placeholder", "onChange"]),
        (_ctx.document.designer_name != _ctx.designer_name_default.value)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              class: "input",
              type: "text",
              placeholder: "Введите название проектировщика",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.document.designer_name) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.document.designer_name]
            ])
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.manufacturer_name_title,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.manufacturer_name_title) = $event)),
          editable: "",
          options: _ctx.manufacturer_name_options,
          optionLabel: "name",
          placeholder: _ctx.manufacturer_name_default.name,
          style: {"width":"480px"},
          onChange: _ctx.manufacturer_name_change
        }, null, 8, ["modelValue", "options", "placeholder", "onChange"]),
        (_ctx.document.manufacturer_name != _ctx.designer_name_default.value)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              class: "input",
              type: "text",
              placeholder: "Введите название изготовителя",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.document.manufacturer_name) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.document.manufacturer_name]
            ])
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}